var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOsfyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 78,
    viewBox: "0 0 186 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3718 4.524C12.3592 4.524 0 16.692 0 32.76C0 48.906 12.3592 61.074 28.3718 61.074C44.3844 61.074 56.6659 48.906 56.6659 32.76C56.6659 16.692 44.3844 4.524 28.3718 4.524ZM28.3718 15.132C38.0882 15.132 45.3949 22.62 45.3949 32.76C45.3949 42.978 38.0882 50.466 28.3718 50.466C18.5777 50.466 11.271 42.978 11.271 32.76C11.271 22.62 18.5777 15.132 28.3718 15.132Z",
    fill: "#1961FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1986 26.13V17.16H65.3183V42.9H87.083V51.168H65.3183V60.06H98.1986V33.384H76.4339V26.13H98.1986Z",
    fill: "#1961FD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112.323 60.06H123.439V33.228H137.663V22.698H123.439V10.53H137.663V0H112.323V22.698H104.939V33.228H112.323V60.06Z",
    fill: "#1961FD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M158.95 78L186 17.16H174.185L163.536 41.964L152.964 17.16H141.071L157.628 54.366L147.134 78H158.95Z",
    fill: "#1961FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOsfyLogo);
export default __webpack_public_path__ + "static/media/osfyLogo.5a70e00fe560b523cb9f5bf59ae13ea2.svg";
export { ForwardRef as ReactComponent };